<template>
  <div class="container-fluid" >
  <div class="card">
    <div class="card-header">
      JLINK
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="jlink-select">Тип команды</label>
        <select  class="custom-select select-width"  v-model="jlinkSelected"
                 id="jlink-select">
          <option value="">Выберите ...</option>
          <option v-for="command in jlinkCommands" :value="command">
            {{ command }}
          </option>
        </select>
      </div>
      <form>
        <input type="file" @change="onDocJlinkChange" class="mb-3">
      </form>
      <button type="button" @click="jlinkSave" class="btn btn-primary" >Отправить</button>
    </div>
  </div>
    <div class="card">
    <div class="card-header">
      STARP
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="starp-select">Тип команды</label>
        <select  class="custom-select select-width"  v-model="starpSelected"
                 id="starp-select">
          <option value="">Выберите ...</option>
          <option v-for="command in starpCommands" :value="command">
            {{ command }}
          </option>
        </select>
      </div>
      <form>
        <input type="file" @change="onDocStarpChange" class="mb-3">
      </form>
      <button type="button" @click="starpSave" class="btn btn-primary" >Отправить</button>
    </div>
  </div>
  </div>
</template>


<script>
  import api from '@/api'

  export default {
    data () {
      return {
        jlinkCommands: [
          'ping', 'inf', 'cfg', 'eva', 'mdb', 'jinfo', 'jconfig', 'jlog',
        ],
        starpCommands: [
          'cfgprg', 'man', 'evaprg', 'mdb', 'bin', 'gsmstatus', 'gsmexplore', 'jconfigprg', 'jlogreset',
          'reboot', 'jstatreset', 'jfabreset', 'wait1s', 'wait5s', 'wait30s', 'wait1m', 'wait5m', 'wait1h',
        ],
        jlinkSelected: '',
        starpSelected: '',
        jlinkFile: null,
        starpFile: null,
      }
    },
    methods: {
      onFileChange(e) {
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        return files[0]
      },
      onDocJlinkChange(e) {
        this.jlinkFile = this.onFileChange(e)
      },
      onDocStarpChange(e) {
        this.starpFile = this.onFileChange(e)
      },
      jlinkSave() {
        if (this.jlinkSelected !== '') {
          let data = new FormData()
          data.append('doc', this.jlinkFile)
          data.append('command', this.jlinkSelected)
          const config = {
            headers: {'content-type': 'multipart/form-data'},
          }
          api.post(`emulator/jlink`, data, config)
        }
      },
      starpSave() {
        if (this.starpSelected !== '') {
          let data = new FormData()
          data.append('doc', this.starpFile)
          data.append('command', this.starpSelected)
          const config = {
            headers: {'content-type': 'multipart/form-data'},
          }
          api.post(`emulator/starp`, data, config)
        }
      },
    },
  }

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/emulator.vue